import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import VolumeIcon from '@assets/svgs/learn/volume.svg'
import {Progress} from 'antd'

const ItemSentence = ({data, type}: any) => {
  return (
    <Box
      borderRadius={'16px'}
      cursor={'pointer'}
      _hover={{
        bg: '#E6F7FF',
      }}>
      <Flex
        p={'16px'}
        gap={'16px'}
        justifyContent={'space-between'}
        alignItems={'center'}>
        <Flex>
          <Progress
            type="circle"
            percent={Number(data?.process_percentage)}
            size={40}
          />
        </Flex>
        <Flex flexDirection={'column'} flex={1}>
          <Flex gap={'8px'} flexDirection={'column'}>
            <Text fontSize={'16px'}>{data?.data?.text_en}</Text>
            <Text fontSize={'16px'}>{data?.data?.text_vi}</Text>
          </Flex>
        </Flex>
        {type === 'complete' ? (
          <Text fontSize={'16px'} fontWeight={600}>
            {true &&
              ` Ôn lại sau ${Math.abs(data?.data?.practice_days_remaining)} ngày`}
          </Text>
        ) : (
          <Center
            w={'40px'}
            h={'40px'}
            borderRadius={'50%'}
            border={'1px solid #FFC069'}
            flexShrink={0}>
            <Image src={VolumeIcon} />
          </Center>
        )}
      </Flex>
    </Box>
  )
}

export default ItemSentence
